import React from 'react';
import { TimelineItemAllColours } from '../../';
import ItemWithTooltip from './ItemWithTooltip';

type Props = {
  item: any;
  isSimple: boolean;
  isExpanded: boolean;
};

export default function AllColoursItem({ item, isSimple, isExpanded }: Props) {
  return (
    <ItemWithTooltip item={item}>
      <TimelineItemAllColours
        item={item}
        isSimple={isSimple}
        isExpanded={isExpanded}
      />
    </ItemWithTooltip>
  );
}
